import { render, staticRenderFns } from "./QuestionTemplateRemoveDialog.vue?vue&type=template&id=53b80d26&scoped=true"
import script from "./QuestionTemplateRemoveDialog.vue?vue&type=script&lang=js"
export * from "./QuestionTemplateRemoveDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionTemplateRemoveDialog.vue?vue&type=style&index=0&id=53b80d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b80d26",
  null
  
)

export default component.exports